<template>
    <div class="row">
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-5">
            <div class="card dash-widget">
                <div class="card-body">
                    <span class="dash-widget-icon">
                        <i class="fa fa-comment"></i>
                    </span>
                    <div class="dash-widget-info">
                        <h3>
                            {{ statAIChatBot.total }}
                        </h3>
                        <span>
                            Daftar AI & Chat Bot
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center">
                            <div class="table-responsive">
                                <table class="table mb-0">
                                    <tbody>
                                        <tr>
                                            <td class="text-center">
                                                <router-link :class="'btn btn-white btn-sm m-t-10'"
                                                    :to="'/agent-ai-v2'">
                                                    <h3>
                                                        {{ statAIChatBot.balasOtomatis }}
                                                    </h3> Balas Otomatis
                                                </router-link>
                                            </td>
                                            <td class="text-center">
                                                <router-link :class="'btn btn-white btn-sm m-t-10'"
                                                    :to="'/agent-ai-v2'">
                                                    <h3>
                                                        {{ statAIChatBot.balasJamKerja }}

                                                    </h3> Balas Dijam Kerja
                                                </router-link>

                                            </td>
                                            <td class="text-center">
                                                <router-link :class="'btn btn-white btn-sm m-t-10'"
                                                    :to="'/agent-ai-v2'">
                                                    <h3>
                                                        {{ statAIChatBot.balasLuarJamKerja }}
                                                    </h3> Balas Diluar Kerja
                                                </router-link>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-7">
            <div class="card dash-widget">
                <div class="card-body">
                    <span class="dash-widget-icon">
                        <i class="fa fa-magic"></i>
                    </span>
                    <div class="dash-widget-info">
                        <h3>
                            &nbsp;
                        </h3>
                        <span>
                            Sesi &amp; Rangkuman AI Chat
                        </span>
                    </div>
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center">
                            <div class="table-responsive">
                                <table class="table mb-0">
                                    <tbody>
                                        <tr>
                                            <td class="text-wrap text-center">
                                                <router-link :class="'btn btn-success btn-sm m-t-10'"
                                                    :to="'/aikey?status=running'">
                                                    <h3 class="text-white">
                                                        {{ statAIChat.totalActive }}
                                                    </h3> Sesi Aktif
                                                </router-link>

                                            </td>
                                            <td class="text-wrap text-center">
                                                <router-link :class="'btn btn-primary btn-sm m-t-10'"
                                                    :to="'/aikey?status=paused'">
                                                    <h3 class="text-white">
                                                        {{ statAIChat.totalDitunda }}
                                                    </h3> Sesi Ditunda
                                                </router-link>
                                            </td>

                                            <td class="text-wrap text-center">
                                                <router-link :class="'btn btn-white btn-sm m-t-10'"
                                                    :to="'/aikey?status=closed'">
                                                    <h3>
                                                        {{ statAIChat.totalSelesai }}
                                                    </h3> Sesi Selesai
                                                </router-link>

                                            </td>
                                            <td class="text-wrap text-center">
                                                <router-link :class="'btn btn-danger btn-sm m-t-10'"
                                                    :to="'/aisummary?status=not_follow_up'">
                                                    <h3 class="text-white">
                                                        {{ statAIChatSummary.needFollowUp }}
                                                    </h3> Perlu Follow Up
                                                </router-link>

                                            </td>
                                            <td class="text-wrap text-center">
                                                <router-link :class="'btn btn-info btn-sm m-t-10'"
                                                    :to="'/aisummary?status=follow_up'">
                                                    <h3 class="text-white">
                                                        {{ statAIChatSummary.followUpHasScheduled }}
                                                    </h3> Follow Up Dijadwalkan
                                                </router-link>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>
<script>
export default {
    components: {},
    data() {
        return {
            statAIChatBot: {
                total: 0,
                balasOtomatis: 0,
                balasJamKerja: 0,
                balasLuarJamKerja: 0
            },
            statAIChat: {
                totalActive: 0,
                totalDitunda: 0,
                totalSelesai: 0
            },
            statAIChatSummary: {
                needFollowUp: 0,
                followUpHasScheduled: 1
            }
        };
    },
    async created() {
        this.getStatAIChatBot();
        await this.getStatAIChat();
        await this.getStatAIChatSummary();
    },
    methods: {
        async getStatAIChatBot() {
            this.$store
                .dispatch("dashboard/statAIChatBot") // sesuai kan dengan method di API
                .then(response => {
                    var { data } = response
                    this.statAIChatBot = data
                });
        },
        async getStatAIChat() {
            this.$store
                .dispatch("dashboard/statAIChat") // sesuai kan dengan method di API
                .then(response => {
                    var { data } = response
                    this.statAIChat = data
                });
        },
        async getStatAIChatSummary() {
            this.$store
                .dispatch("dashboard/statAIChatSummary") // sesuai kan dengan method di API
                .then(response => {
                    var { data } = response
                    this.statAIChatSummary = data
                });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/dashboard/components/ChatBot.vue